import React, { Component } from "react";
import { debounce } from 'throttle-debounce';
import Icons from "../../icon";
import { Form, Button, FloatingLabel, DropdownButton } from 'react-bootstrap';
import Autosuggest from 'react-autosuggest';
import './custom-form.component.css';
import { sliceArray } from "../../../utils/helpers.utils";

export class InputField extends Component {

    render(){
        const { label, onChange, inputValue, customClass, placeholder, customWrapper, isDisable, requiredField, onBlur, maxLength, disabled, name, type, hasError, onBeforeInput } = this.props;
        var disableClass = isDisable ? 'disabled' : '';
        return (
            <div className={`custom-input-wrapper ${requiredField ? "required":""} ${hasError ? 'border-red' : ''} ${customWrapper} ${disableClass}`}>
                <div className={`custom-input-container ${customClass}`}>
                    <div className="custom-input-label">{label}</div>
                    <input type={type ? type : "text"} name={`${name || 'value'}`}
                        value={inputValue ? inputValue : ""}
                        placeholder={placeholder}
                        className="input-filter"
                        onChange={onChange}
                        onBlur={onBlur}
                        maxLength={maxLength}
                        disabled={disabled}
                        onBeforeInput={onBeforeInput}
                    />
                </div>
            </div>
        );
    }
}

export class CustomSearchableSelectKeyValue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            showOptions: false,
        };
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({ showOptions: false });
        }
    };

    handleSearchChange = (e) => {
        this.setState({ search: e.target.value });
        // filtering and slicing
    };

    handleOptionClick = (option) => {
        const { onChange } = this.props;
        this.setState({ search: '', showOptions: false });
        var valObj = {
            target: {
                tagName: "SEARCHABLE-SELECT",
            },
            value: option.Key,
            text: option.Value

        };
        onChange(valObj);
    };

    handleBlur = () => {
        const { search } = this.state;
        const { options } = this.props;
        const filteredOptions = search === "" ? options : options.filter(option =>
            option.Value.toLowerCase().includes(search.toLowerCase())
        ).slice(0, 10);

        const match = filteredOptions.some(option => option.Value.toLowerCase() === search.toLowerCase());

        if (!match && !this.state.showOptions) {
            this.setState({ search: '' });
        }
    };

    render() {
        const { label, options, selected, placeholder, requiredField, model, maxLength, onBlurAction, disabled } = this.props;
        const { search, showOptions } = this.state;

        const filteredOptions = search === ""? options : options.filter(option =>
            option.Value.toLowerCase().includes(search.toLowerCase())
        ).slice(0, 10);

        return (
            <div ref={this.wrapperRef} className={`custom-select-wrapper ${this.props.customClass} ${disabled ? "disabled" : ""} ${requiredField ? "required" : ""}`}>
                {
                    label &&
                    <div className="custom-select-label">{label}</div>
                }
                <input
                    className={`custom-select-input {${disabled ? 'disabled' : ''} form-select`}
                    type="text"
                    placeholder={placeholder}
                    value={showOptions ? search : selected}
                    onChange={this.handleSearchChange}
                    onFocus={() => this.setState({ showOptions: true })}
                    onBlur={this.handleBlur}
                    model={ model }
                    maxLength={maxLength}
                    disabled={disabled}
                />
                {showOptions && (
                    <ul className="custom-select-options">
                        {filteredOptions.map(option => (
                            <li
                                key={option.Key}
                                onClick={() => this.handleOptionClick(option)}
                                className="custom-select-option"
                            >
                                {option.Value}
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }
}



